export default __webpack_public_path__ + "static/media/attendance-white.f7ac8a46.svg";